import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { FaTwitter } from 'react-icons/fa';

const Footer = () => (
	<StaticQuery
		query={graphql`
			query SocialQuery {
				site {
					siteMetadata {
						facebook
						twitter
						youtube
						aviro
						msf
					}
				}
			}
		`}

		render={data => (
			<React.Fragment>
			<div className="fb-yt-band">
			<div className="fb-yt-group">
				<span>see more on</span> <a href={data.site.siteMetadata.youtube} className="footer-yt"><span>YouTube</span><i>&nbsp;</i></a> <a href={data.site.siteMetadata.facebook} className="footer-fb"><span>Facebook</span><i>&nbsp;</i></a><a href={data.site.siteMetadata.twitter} className="footer-tw"><span>Twitter</span><FaTwitter size={28} color="white" /></a>
			</div>
			</div>
			<footer className="footer center">
				<div className="content has-text-centered">
					<div className="columns is-mobile">
						<div className="column is-10 is-offset-1">
							<div className="columns">
								<div className="column">
									<a href={data.site.siteMetadata.aviro} className="aviro-logo logo-link">&nbsp;</a>
								</div>
								<div className="column">
									<a href={data.site.siteMetadata.msf} className="msf-logo logo-link">&nbsp;</a>
								</div>
							</div>
						</div>
					</div>

				</div>

			</footer>
				<div className="columns after-footer-band">
					<div className="column copyright-details">&copy; {new Date().getFullYear()} Aviro Health and MSF South Africa</div>
					<div className="column made-with">Made with <a className="logo-contentful" href="https://www.contentful.com/" target="_blank" rel="noopener noreferrer" >&nbsp;</a> & <a href="https://www.gatsbyjs.org/" className="logo-gatsby" target="_blank" rel="noopener noreferrer">&nbsp;</a></div>
				</div>

			</React.Fragment>
		)}
	/>
);

export default Footer;
